import Vue, {PropType} from 'vue'

export const RatingSelectProps = Vue.extend({
    props: {
        selectedItem: {
            type: String,
            required: true,
            validator: prop => typeof prop === 'string' || prop === null
        },        
        onChange: {
            required: true,
            type: Function as PropType<(selected: string) => void>
        },
        max: {
            required: false,
            default: 10,
            type: Number
        }
    }
})